import { makeStyles } from '@material-ui/styles';

export const useStyles = makeStyles(theme => ({
    strategyList: {
        marginBottom: '0.5rem',
    },
    strategyListChip: {
        margin: '0.25rem',
    },
    strategyListHeader: {
        marginBottom: '0.5rem',
    },
}));
